module.exports = __webpack_public_path__ + "img/logo.5b03692a.png";